<template>
    <div class="body">
      <div class="header">
        <el-form :model="ProductFindDTO" :inline="true">
          <el-form-item label="上传日期">
            <el-date-picker
              size="small"
              v-model="date"
              type="daterange"
              :picker-options="cellClassName"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              format="yyyy 年 MM 月 dd 日"
              value-format="yyyy-MM-dd"
              @change="chooeDate"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="产品名称">
              <el-input
                size="small"
                v-model="ProductFindDTO.category"
              ></el-input>
            </el-form-item>
            <el-form-item label="产品类别">
              <el-input
                size="small"
                v-model="ProductFindDTO.subclass"
              ></el-input>
            </el-form-item>
            <el-form-item label="产品编号">
              <el-input
                size="small"
                v-model="ProductFindDTO.number"
              ></el-input>
            </el-form-item>
          <el-form-item label="产品性质" >
          <el-select clearable size="small" v-model="ProductFindDTO.nature" style="width:120px">
            <el-option
              v-for="item in nature"
              clearable
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
          <el-form-item>
            <el-button size="small" type="primary" @click="serchInfo">
              搜索
            </el-button>
            <el-button @click="tohandleEdit" size="small" type="primary">新增</el-button>
            <el-button size="small" type="danger" @click="handleDelete">删除</el-button>
          </el-form-item>

          <br>
          <el-form-item>

          </el-form-item>

        </el-form>
        <el-dialog
        text-align="center"
        :close-on-click-modal="false"
        title="新增产品"
        :visible.sync="drawer"
        width="500px"
      >
        <el-form
          ref="accountForm"
          :rules="rules"
          :model="accountForm"
          label-width="120px"
          class="demo-accountForm"
        >

        <el-form-item style="margin-top: 5px" label="产品名称" prop="category">
          <el-select clearable size="small" v-model="accountForm.category" allow-create filterable  @blur.native.capture="categorySelect">
            <el-option
              v-for="item in category"
              clearable
              :key="item"
              :label="item"
              :value="item"
            />
          </el-select>
        </el-form-item>

        <el-form-item  label="产品类别" prop="subclass">
          <el-input
            class="input-remark"
            size="small"
            v-model="accountForm.subclass"
            placeholder="请输入产品类别"
          ></el-input>
        </el-form-item>
          <el-form-item  label="单价" prop="listPrice">
          <el-input
            class="input-remark"
            size="small"
            v-model="accountForm.listPrice"
            placeholder="请输入单价"
          ></el-input>
        </el-form-item>
        <el-form-item  label="单位" prop="unit">
          <el-input
            class="input-remark"
            size="small"
            v-model="accountForm.unit"
            placeholder="请输入单位"
          ></el-input>
        </el-form-item>
        <el-form-item  label="规格" prop="specifications">
          <el-input
            class="input-remark"
            size="small"
            v-model="accountForm.specifications"
            placeholder="请输入规格"
          ></el-input>
        </el-form-item>
        <el-form-item  label="物料清单" prop="boringList">
          <el-input
            class="input-remark"
            size="small"
            v-model="accountForm.boringList"
            placeholder="请输入物料清单"
          ></el-input>
        </el-form-item>
        <el-form-item style="margin-top: 20px" label="产品性质" prop="remark">
        <el-select clearable size="small" v-model="accountForm.nature">
          <el-option
            v-for="item in nature"
            clearable
            :key="item.value"
          :label="item.label"
          :value="item.value"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="上传底板文件"  class="errorPageImg">
                       <el-upload
                        class="avatar-uploader"
                        action="api/serviceCenter/miniUpload/miniUpload"
                        name="files"
                        :show-file-list="false"
                        :on-success="miniPathSuccess"
                        >
                        <img v-if="accountForm.floorPath" :src="accountForm.floorPath"  style="max-height: 100px;max-width: 100px ;cursor:pointer" class="avatar">
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                      </el-upload>
        </el-form-item>
            <el-form-item label="上传面板文件"  class="errorPageImg">
                       <el-upload
                        class="avatar-uploader"
                        action="api/serviceCenter/miniUpload/miniUpload"
                        name="files"
                        :show-file-list="false"
                        :on-success="miniPanelPathPathSuccess"
                        >
                        <img v-if="accountForm.panelPath" :src="accountForm.panelPath"  style="max-height: 100px;max-width: 100px ;cursor:pointer" class="avatar">
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                      </el-upload>
                    </el-form-item>
                    <el-form-item label="上传字稿文件"  class="errorPageImg">
                       <el-upload
                        class="avatar-uploader"
                        action="api/serviceCenter/imposition/upload"
                        name="files"
                        :show-file-list="false"
                        :on-success="impositionPathSuccess"
                        >
                        <img v-if="accountForm.impositionPath" :src="accountForm.impositionPath"  style="max-height: 100px;max-width: 100px ;cursor:pointer" class="avatar">
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                      </el-upload>
                    </el-form-item>
                    <el-form-item label="上传存档文件"  class="errorPageImg">
                       <el-upload
                        class="avatar-uploader"
                        action="api/serviceCenter/keep/miniUpload"
                        name="files"
                        :show-file-list="false"
                        :on-success="keepPathSuccess"
                        >
                        <img v-if="accountForm.keepPath" :src="accountForm.keepPath"  style="max-height: 100px;max-width: 100px ;cursor:pointer" class="avatar">
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                      </el-upload>
                    </el-form-item>
                         <el-form-item label="上传缩略图"  class="errorPageImg">
                       <el-upload
                        class="avatar-uploader"
                        action="api/serviceCenter/orderInfo/orderThumbnailUpload"
                        name="files"
                        :show-file-list="false"
                        :on-success="thumbnailPathSuccess"
                        :before-upload="beforeAvatarUpload"
                        >
                        <img v-if="accountForm.thumbnailPath" :src="accountForm.thumbnailPath"  style="max-height: 100px;max-width: 100px ;cursor:pointer" class="avatar">
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                      </el-upload>
                    </el-form-item>
            <el-button
              size="small"
              type="primary"
              @click="submitForm('accountForm')"
            >
              立即创建
            </el-button>

        </el-form>
      </el-dialog>
        <div style="display: flex">
          <!-- <el-button size="small" type="primary">导入</el-button> -->
          <!-- <el-button
            size="small"
            style="margin-left: 10px"
            type="primary"
            @click="exportExcelData"
          >
            导出
          </el-button> -->
        </div>
  </div>
  <div class="pagination">

<el-pagination
  :current-page="currentPage"
  :page-sizes="[10, 30, 50, 100]"
  :page-size="pageSize"
  layout="total, sizes, prev, pager, next, jumper"
  :total="total"
  @size-change="handleSizeChange"
  @current-change="handleCurrentChange"
></el-pagination>
</div>
      <div style="margin: 10px">
        <el-table
          :data="conTract"
          stripe
          border
          style="width: 100%"
          :cell-style="styleBack"
          @selection-change="handleSelectionChange"
        >
        <el-table-column
          type="selection"
          align="center"
          width="55"
        ></el-table-column>
        <el-table-column
            prop="createTime"
            align="center"
            label="上传时间"
            width="180"
          ></el-table-column>
          <el-table-column
            prop="category"
            align="center"
            label="产品名称"
          ></el-table-column>
          <el-table-column
    prop="thumbnailPath"
    label="缩略图"
    align="center"
    width="200" >
 <template slot-scope="scope">
 <el-popover placement="top-start" trigger="click">
 <!--trigger属性值：hover、click、focus 和 manual-->
 <a :href="scope.row.thumbnailPath"  target="_blank" title="查看最大化图片">
 <img :src="scope.row.thumbnailPath" style="max-height: 800px;max-width: 800px">
  </a>
  <img slot="reference" :src="scope.row.thumbnailPath" style="max-height: 50px;max-width: 50px cursor:pointer">
  </el-popover>
 </template>
</el-table-column>
          <el-table-column
            prop="subclass"
            align="center"
            label="产品类别"
            width="130"
          ></el-table-column>
          <el-table-column
              prop="number"
              align="center"
              label="产品编号"
              width="180"
            ></el-table-column>
            <el-table-column
              prop="unit"
              align="center"
              label="单位"
            ></el-table-column>
            <el-table-column
              prop="specifications"
              align="center"
              label="规格"
            ></el-table-column>
            <el-table-column
              prop="listPrice"
              align="center"
              label="单价"
            ></el-table-column>

            <el-table-column
              prop="boringList"
              align="center"
              label="文件清单"
            ></el-table-column>
          <el-table-column
            prop="nature"
            align="center"
            label="产品性质"
            width="100"
          >     <template slot-scope="scope">
            <el-tag type=" info" v-if="scope.row.nature==='0'">常规产品</el-tag>
            <el-tag type="success" v-if="scope.row.nature==='1'">标准件</el-tag>
        </template>
        </el-table-column>

        <el-table-column label="操作" align="center" width="150">
            <template v-slot="{ row }">
              <el-link type="success" size="small" @click="handleEdit(row)">编辑</el-link>
            </template>
          </el-table-column>
        </el-table>
      </div>
  
      <el-dialog
      text-align: center
        :close-on-click-modal="false"
        title="编辑产品"
        :visible.sync="dialogVisible"
        width="500px">
          <el-form
            ref="accountForm"
            :model="accountForm"
            label-width="120px"
            class="demo-accountForm"
          >
          <el-form-item style="margin-top: 5px" label="产品名称" prop="category">
          <el-select clearable size="small" v-model="accountForm.category" allow-create filterable @blur.native.capture="categorySelect">
            <el-option
              v-for="item in category"
              clearable
              :key="item"
              :label="item"
              :value="item"
            />
          </el-select>
        </el-form-item>
        <el-form-item  label="产品类别" prop="subclass">
          <el-input
            class="input-remark"
            size="small"
            v-model="accountForm.subclass"
            placeholder="请输入产品类别"
          ></el-input>
        </el-form-item>

        <el-form-item  label="单价" prop="listPrice">
          <el-input
            class="input-remark"
            size="small"
            v-model="accountForm.listPrice"
            placeholder="请输入单价"
          ></el-input>
        </el-form-item>
        <el-form-item  label="单位" prop="unit">
          <el-input
            class="input-remark"
            size="small"
            v-model="accountForm.unit"
            placeholder="请输入单位"
          ></el-input>
        </el-form-item>
        <el-form-item  label="规格" prop="specifications">
          <el-input
            class="input-remark"
            size="small"
            v-model="accountForm.specifications"
            placeholder="请输入规格"
          ></el-input>
        </el-form-item>
        <el-form-item  label="物料清单" prop="boringList">
          <el-input
            class="input-remark"
            size="small"
            v-model="accountForm.boringList"
            placeholder="请输入物料清单"
          ></el-input>
        </el-form-item>
            <el-form-item style="margin-top: 20px" label="产品性质" prop="remark">
            <el-select clearable size="small" v-model="accountForm.nature"  filterable
      allow-create
      default-first-option>
              <el-option
                v-for="item in nature"
                clearable
                :key="item.value"
          :label="item.label"
          :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="上传底板文件"  class="errorPageImg">
                       <el-upload
                        class="avatar-uploader"
                        action="api/serviceCenter/miniUpload/miniUpload"
                        name="files"
                        :show-file-list="false"
                        :on-success="miniPathSuccess"
                        :before-upload="beforeAvatarUpload1"
                        >
                        <img v-if="accountForm.floorPath" :src="accountForm.floorPath"  style="max-height: 100px;max-width: 100px cursor:pointer" class="avatar">
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                      </el-upload>
                    </el-form-item>
                    <el-form-item label="上传面板文件"  class="errorPageImg">
                       <el-upload
                        class="avatar-uploader"
                        action="api/serviceCenter/miniUpload/miniUpload"
                        name="files"
                        :show-file-list="false"
                        :on-success="miniPanelPathPathSuccess"
                        :before-upload="beforeAvatarUpload1"
                        >
                        <img v-if="accountForm.panelPath" :src="accountForm.panelPath"  style="max-height: 100px;max-width: 100px cursor:pointer" class="avatar">
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                      </el-upload>
                    </el-form-item>
                    <el-form-item label="上传字稿文件"  class="errorPageImg">
                       <el-upload
                        class="avatar-uploader"
                        action="api/serviceCenter/imposition/upload"
                        name="files"
                        :show-file-list="false"
                        :on-success="impositionPathSuccess"
                        :before-upload="beforeAvatarUpload1"
                        >
                        <img v-if="accountForm.impositionPath" :src="accountForm.impositionPath"  style="max-height: 100px;max-width: 100px cursor:pointer" class="avatar">
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                      </el-upload>
                    </el-form-item>
                    <el-form-item label="上传存档文件"  class="errorPageImg">
                       <el-upload
                        class="avatar-uploader"
                        action="api/serviceCenter/keep/miniUpload"
                        name="files"
                        :show-file-list="false"
                        :on-success="keepPathSuccess"
                        :before-upload="beforeAvatarUpload1"
                        >
                        <img v-if="accountForm.keepPath" :src="accountForm.keepPath"  style="max-height: 100px;max-width: 100px cursor:pointer" class="avatar">
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                      </el-upload>
                    </el-form-item>
                    <el-form-item label="上传缩略图"  class="errorPageImg">
                       <el-upload
                        class="avatar-uploader"
                        action="api/serviceCenter/orderInfo/orderThumbnailUpload"
                        name="files"
                        :show-file-list="false"
                        :on-success="thumbnailPathSuccess"
                        :before-upload="beforeAvatarUpload"
                        >
                        <img v-if="accountForm.thumbnailPath" :src="accountForm.thumbnailPath"  style="max-height: 100px;max-width: 100px cursor:pointer" class="avatar">
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                      </el-upload>
                    </el-form-item>

          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button size="small" @click="dialogVisible = false">取 消</el-button>
            <el-button size="small" type="primary" @click="editAccount()">
              确 定
            </el-button>
          </span>
        </el-dialog>
    </div>
  </template>

  <script>
  import {addProduct,selectProductCategory,productSelectInfo,bathDeleteProduct,upDateProduct} from '@/api/order/product'
  export default {
    data() {
      return {
        isLock: false,
        pageSize: 10,
        dialogVisible: false,
        drawer:false,
        param:'1800',
        total: 0,
        currentPage: 1,
        materialType:[],
        multipleSelection: [],
        category:[],
        compositionStatus:[{
          value: '0',
          label: '未拼版'
        }, {
          value: '1',
          label: '已拼版'
        }],
        nature: [{
          value: '0',
          label: '常规产品'
        }, {
          value: '1',
          label: '标准件'
        }],
        rules:{
                    category:[
                    { required: true, message: '请输入产品分类:大类', trigger: 'blur' }],
                    subclass:[
                    { required: true, message: '请输入产品分类:小类', trigger: 'blur' }],

            },
        cellClassName: {
          shortcuts: [
          {
              text: '最近一天',
              onClick(picker) {
                const end = new Date()

                const start = new Date()

                picker.$emit('pick', [start, end])
              }
            },
            {
              text: '最近三天',
              onClick(picker) {
                const end = new Date()

                const start = new Date()
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 2)
                picker.$emit('pick', [start, end])
              }
            },
            {
              text: '最近一周',
              onClick(picker) {
                const end = new Date()

                const start = new Date()
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 6)
                picker.$emit('pick', [start, end])
              }
            },
            {
              text: '最近一个月',
              onClick(picker) {
                const end = new Date()

                const start = new Date()
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 29)
                picker.$emit('pick', [start, end])
              }
            },
            {
              text: '最近三个月',
              onClick(picker) {
                const end = new Date()

                const start = new Date()
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 89)
                picker.$emit('pick', [start, end])
              }
            }
          ]

        },
        date: '',
        conTract: [],
        buttonInfo:[],
        ProductFindDTO:{
          fileName:'',
          materialType:'',
            startTime: '',
            endTime: '',
            access: '',
            name:'',
            number:'',
            category:'',
            subclass:'',
            nature:'',
        },
        accountForm: {
            name:'',
            category:'',
            subclass:'',
            number:'',
            unit:'',
            specifications:'',
            listPrice:'',
            lowestSellingPrice:'',
            boringList:'',
            nature: '',
            id:'',
            access:'',
            floorPath:'',
            panelPath:'',
            impositionPath:'',
            thumbnailPath:'',
            keepPath:''
          },
        searchForm: {
          startTime: '',
          secondStartTime: '',
          number: '',
          values: ''
        },
        DeleteDTO:{
          id:'',
          status:''
        }
      }
    },
    beforeMount(){

    },

    async  mounted() {
      this.ProductFindDTO.access=localStorage.getItem("access")
      this.getTableData();

    },
    methods: {
      categorySelect(e){
        if(e.target.value) { 
                    this.accountForm.category = e.target.value
            }
      },
      styleBack({ row, column, rowIndex, columnIndex }) {
        // if (columnIndex == 0) {
        //   return { color: '#0c87ef' }
        // }
      },
      miniPathSuccess(res, file){
        this.accountForm.floorPath = res.data.ori_file[0];
      },
      impositionPathSuccess(res, file){
        this.accountForm.impositionPath = res.data.ori_file[0];
      },
      miniPanelPathPathSuccess(res, file){
        this.accountForm.panelPath = res.data.ori_file[0];
      },
      keepPathSuccess(res, file){
        this.accountForm.keepPath = res.data.ori_file[0];
      },
      thumbnailPathSuccess(res, file){
        this.accountForm.thumbnailPath = res.data.ori_file[0];
      },
      tohandleEdit(){
        this.accountForm = Object.assign({},this.$options.data().accountForm);
        this.accountForm.access=localStorage.getItem("access")
        this.drawer = true
      },

      submitForm(accountForm) {
        this.$refs[accountForm].validate((valid) => {
          if (valid) {
            addProduct(this.accountForm).then((res) => {
                  if (res.data.msg === '操作成功') {
              this.drawer = false
              this.$message({
                type: 'success',
                message: '添加成功!',

              }),
              this.getTableData()

            } else if (res.data.msg !== '操作成功') {
              this.$message({
                type: 'info',
                message: res.data.data
              })
            }
            })
          } else {
            console.log('error submit!!')
            return false
          }
        })
      },
      getProduct(){

      },
      handleSizeChange(val) {
        this.pageSize = val
        this.getTable()
      },
      handleCurrentChange(val) {
        this.currentPage = val
        this.getTable()
      },
    async  getTableData() {
      await  selectProductCategory(this.ProductFindDTO).then((res)=>{
        if(res.data.code===10000){
              this.buttonInfo=res.data.data
              this.category=res.data.data
            }
      })
        productSelectInfo(this.currentPage, this.pageSize, this.ProductFindDTO).then((res) => {
          this.conTract = res.data.data.records
          this.total = Number(res.data.data.total)
        })
      },
      handleEdit(row){
          this.dialogVisible=true
          this.accountForm=row
      },
      editAccount() {
        upDateProduct(this.accountForm).then((res) => {
            console.log(res.status)
            if (res.data.msg === '操作成功') {
                this.$message({
                  type: 'success',
                  message: '修改成功!',
                }),
                this.getTable()
                this.dialogVisible = false
              } else if (res.data.msg !== '操作成功') {
                this.$message({
                  type: 'info',
                  message: res.data.data
                })
              }
          })
        },
        beforeAvatarUpload(file) {
        const isJPG = file.type === 'image/jpeg' || file.type === 'image/jpg' || file.type === 'image/png'
        const isLt2M = file.size / 1024 / 1024 < 2;
        if (!isJPG) {
          this.$message.error('上传缩略图图片只能是 JPG/PNG/JPEG 格式!');
        }
        if (!isLt2M) {
          this.$message.error('上传缩略图大小不能超过 2MB!');
        }
        return isJPG && isLt2M;
      },
        beforeAvatarUpload1(file) {
        const isLt20M = file.size / 1024 / 1024 < 20;
        if (!isLt20M) {
          this.$message.error('上传文件大小不能超过 20MB!');
        }
        return  isLt20M;
      },
      getCurrentTime() {
        //获取当前时间并打印
        var _this = this;
    let yy = new Date().getFullYear();
    let mm = new Date().getMonth()+1;
    let dd = new Date().getDate();
    let hh = new Date().getHours();
    let mf = new Date().getMinutes()<10 ? '0'+new Date().getMinutes() : new Date().getMinutes();
    let ss = new Date().getSeconds()<10 ? '0'+new Date().getSeconds() : new Date().getSeconds();
    _this.gettime = yy+'年'+mm+'月'+dd+'日'+hh+'点'+mf+'分'+ss+'秒';
    console.log(_this.gettime)
    return _this.gettime;
    },
      handleDelete(row) {
        if(this.multipleSelection.length==0){
            this.$message({
              type: "error",
              message: "sorry,你还没有勾选呢!"
            });
            return;
          }
      this.$confirm('您真的确定要删除吗？\n\n请确认！！！！！', '删除确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          bathDeleteProduct(this.multipleSelection).then((res) => {
            if (res.data.msg === '操作成功') {
              this.$message({
                type: 'success',
                message: '删除成功!',
              }),
              this.getTable()

            } else if (res.data.msg !== '操作成功') {
              this.$message({
                type: 'info',
                message: res.data.data
              })
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    find(data){
      this.ProductFindDTO.category=data
       this.getTable();
    },

    getTable(){
       selectProductCategory(this.ProductFindDTO).then((res)=>{
        if(res.data.code===10000){
              this.buttonInfo=res.data.data
          //  this.ProductFindDTO.category=res.data.data[0]
            }
      })
        productSelectInfo(this.currentPage, this.pageSize, this.ProductFindDTO).then((res) => {
          this.conTract = res.data.data.records
          this.total = Number(res.data.data.total)
        })
    },
      deleteInfo(){
        bathDeleteFile(this.multipleSelection).then((res) => {
            if(res.data.code===10000){
              this.getTable()
            }
        })
      },

      handleSelectionChange(val) {
        this.DeleteDTO=val
        this.multipleSelection = val;
      },
      // 导出
      exportExcelData() {
        exportData(this.searchForm, this.currentPage, this.total)
          .then((res) => {
            if (res.status == 200) {
              exportExcel(res.data, res)
              this.$message({
                type: 'success',
                message: '导出成功!'
              })
            }
          })
          .catch((error) => {
            console.log(error)
          })
      },
      chooeDate(e) {
        // console.log(e)
        if (e) {
          this.ProductFindDTO.startTime = e[0]
          this.ProductFindDTO.endTime = e[1]
        } else if (!e) {
          this.ProductFindDTO.startTime = ''
          this.ProductFindDTO.endTime = ''
        }
      },
      // 搜索
      serchInfo() {
        this.getTableData()
      },


  }
  }
  </script>

  <style lang="scss" scoped>
  .header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin: 20px;
  }
  .body {
    overflow: auto;
  }

  .pagination {
    margin-top: 10px;
    margin-right: 20px;
    display: flex;
    justify-content: flex-end;
    align-items: flex-end;
    position: relative;
  }
  .el-pagination ::v-deep.el-pagination__total {
    line-height: 36px;
  }
  </style>
